import React, { createContext, useContext, useState } from 'react';

const PagingContext = createContext();

const PagingProvider = ({ children }) => {
    const [paging, setPaging] = useState({
        currentPage: 1,
        totalItems: 0,
        itemsPerPage: 0
    });


    const contextValue = {
        paging,
        setPaging: (newPage) => setPaging((prevPage) => ({ ...prevPage, ...newPage })),
    }

    return (
        <PagingContext.Provider value={contextValue}>
            {children}
        </PagingContext.Provider>
    );
};

const usePagingContext = () => {
    return useContext(PagingContext);
};

export { PagingProvider, usePagingContext, PagingContext };

